import { store } from "@/store/store";
import { dispositivo } from "@/shared/dtos/dispositivo";
import {
  VuexModule,
  Mutation,
  getModule,
  Module,
  Action,
} from "vuex-module-decorators";
import { ssmHttpService } from "@/shared/services/http-service";
import { API } from "@/shared/api";

@Module({
  namespaced: true,
  name: "dispositivoModule",
  store,
  dynamic: true,
})
class dispositivoModule extends VuexModule {
  public dispositivos: dispositivo[] = [];
  public dispositivo: dispositivo = new dispositivo();

  @Action({ commit: "onGetdispositivos" })
  public async getdispositivos() {
    return await ssmHttpService.get(API.dispositivo);
  }

  @Action({ commit: "onGetdispositivo" })
  public async getdispositivo(id: any) {
    return await ssmHttpService.get(API.dispositivo + "/" + id);
  }

  @Action({ commit: "onGetdispositivos" })
  public async getdispositivoByRecurso(id: any) {
    return await ssmHttpService.get(API.dispositivo + "/recurso/" + id);
  }

  @Action
  public async guardardispositivo(dispositivo: dispositivo) {
    /*toJson() no existe pero existe en la extends de BaseDto*/
    await ssmHttpService.post(API.dispositivo, dispositivo.toJson());
    this.getdispositivos();
  }

  @Action
  public async modificardispositivo(dispositivo: dispositivo) {
    await ssmHttpService.put(
      API.dispositivo + "/" + dispositivo.id,
      dispositivo
    );
    this.getdispositivos();
  }

  @Action
  public async eliminardispositivo(dispositivo: dispositivo) {
    await ssmHttpService.delete(
      API.dispositivo + "/" + dispositivo.id,
      null,
      false
    );
    this.getdispositivos();
  }

  @Mutation
  public onGetdispositivos(res: dispositivo[]) {
    this.dispositivos = res ? res.map((x) => new dispositivo(x)) : [];
  }

  @Mutation
  public onGetdispositivo(res: dispositivo) {
    this.dispositivo = new dispositivo(res);
  }
}
export default getModule(dispositivoModule);
